<script>
import { mapGetters } from "vuex"
import moment from "moment-timezone"

export default {
  name: "NavComponent",
  computed: {
    ...mapGetters({
      appPassesNotf: "studentAptPass/todaysAppSidebarCounter",
      user: "authentication/user",
      releases: "releases/releases",
      isUserUnavailable: "authentication/isUserUnavailable",
      unavailable: "dashboardTable/unavailable"
    }),
    OutOfOfficeBadge() {
      return this.isUserUnavailable || this.unavailable ? "bg-green" : "d-none"
    },
    sidebarItems() {
      return [
        {
          _name: "CSidebarNav",
          _children: [
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "Digital ID",
              to: "/id-card",
              fontIcon: "fi flaticon-profile-line",
              requiredRoles: ["student"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "Create Pass",
              to: "/passes/create",
              fontIcon: "fi flaticon-create-pass",
              requiredRoles: ["student"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "Active Pass",
              to: "/passes/activepass",
              fontIcon: "fi flaticon-compass",
              requiredRoles: ["student"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "Dashboard",
              _attrs: {
                "data-test-class": "nav-item"
              },
              to: "/dashboard",
              fontIcon: "flaticon flaticon-home",
              requiredRoles: ["superadmin", "admin", "teacher", "staff"]
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "Pass History",
              to: "/pass-history",
              fontIcon: "fi flaticon-hourglass",
              requiredRoles: ["superadmin", "admin", "teacher", "staff"],
              hidden: true,
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "Teacher Pass (Proxy Pass)",
              to: "/teacher-pass",
              fontIcon: "fi flaticon-key",
              requiredRoles: ["superadmin", "admin", "teacher", "staff"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "Appointment Pass",
              to: "/appointment-pass",
              fontIcon: "fi flaticon-calendar",
              _attrs: {
                "data-test-id": "AppointmentPass",
                "data-test-class": "nav-item"
              },
              requiredRoles: [
                "superadmin",
                "admin",
                "teacher",
                "staff",
                "student"
              ],
              requiredModule: "Appointmentpass",
              badge:
                this.appPassesNotf &&
                this.appPassesNotf > 0 &&
                this.user.role.name == "student"
                  ? {
                      _class: "bg-red-gradient text-white",
                      color: "bg-red-gradient text-white",
                      text: this.appPassesNotf
                    }
                  : {}
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "Kiosk",
              to: "/kiosks",
              _attrs: {
                "data-test-id": "Kiosk",
                "data-test-class": "nav-item"
              },
              fontIcon: "fi flaticon-monitor",
              requiredRoles: ["superadmin", "admin", "teacher", "staff"],
              requiredModule: "Kiosk"
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "Out of office",
              to: "/out-of-office",
              fontIcon: "fi flaticon-briefcase",
              requiredRoles: ["superadmin", "admin", "teacher", "staff"],
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-id": "out-of-office"
              },
              badge: {
                color: this.OutOfOfficeBadge,
                text: "ON"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "New Release",
              to: "/new-releases",
              fontIcon: "fi flaticon-earth-grid",
              _attrs: {
                "data-test-class": "nav-item"
              },
              requiredRoles: [
                "superadmin",
                "admin",
                "teacher",
                "staff",
                "student"
              ],
              badge:
                this.newReleases.length > 0
                  ? {
                      color: "bg-gradient-blue",
                      text: "NEW"
                    }
                  : {}
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: "Tardy Management",
              to: "/tardy-management/",
              fontIcon: "fi flaticon-information",
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              requiredRoles: ["superadmin", "admin", "teacher", "staff"],
              requiredModule: "Tardy Management",
              items: [
                {
                  component: "CNavItem",
                  name: "Tardy Reports",
                  to: "/tardy-management/reports",
                  fontIcon: "fi flaticon-information",
                  "data-test-class": "nav-item",
                  requiredRoles: ["superadmin", "admin", "teacher", "staff"]
                },
                {
                  component: "CNavItem",
                  name: "Tardy Appointments",
                  to: "/tardy-management/appointments",
                  fontIcon: "fi flaticon-information",
                  "data-test-class": "nav-item",
                  requiredRoles: ["superadmin", "admin", "teacher", "staff"]
                },
                {
                  component: "CNavItem",
                  name: "Detention Attendance",
                  to: "/tardy-management/detention-attendance",
                  fontIcon: "fi flaticon-information",
                  requiredRoles: ["superadmin", "admin", "teacher", "staff"]
                }
              ]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: "Training",
              to: "/training/",
              fontIcon: "fi flaticon-information",
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              requiredRoles: [
                "superadmin",
                "admin",
                "teacher",
                "staff",
                "student"
              ],
              items: [
                {
                  component: "CNavItem",
                  name: "Documents",
                  to: "/training/documents",
                  fontIcon: "fi flaticon-pencil",
                  _attrs: {
                    "data-test-class": "nav-item"
                  },
                  requiredRoles: [
                    "superadmin",
                    "admin",
                    "teacher",
                    "staff",
                    "student"
                  ]
                },
                {
                  name: "Video Tutorials",
                  component: "CNavItem",
                  to: "/training/videos",
                  fontIcon: "fi flaticon-video",
                  _attrs: {
                    "data-test-class": "nav-item"
                  },
                  requiredRoles: [
                    "superadmin",
                    "admin",
                    "teacher",
                    "staff",
                    "student"
                  ]
                }
                // {
                //   name: "Admin's Guide",
                //   to: '/training/admin-guide',
                //   fontIcon: "fi flaticon-video",
                //   requiredRoles: ['superadmin', 'admin', ],
                // },
                // {
                //   name: "Teacher's Guide",
                //   to: '/training/teacher-guide',
                //   fontIcon: "fi flaticon-video",
                //   requiredRoles: ['superadmin', 'admin', 'teacher', 'staff'],
                // },
                // {
                //   name: 'Video Tutorials',
                //   to: '/training/video-tutorials',
                //   fontIcon: "fi flaticon-video",
                //   requiredRoles: ['superadmin', 'admin', 'teacher', 'staff', 'student'],
                // },
                // {
                //   name: 'Quick Reference Card',
                //   to: '/training/quick-reference',
                //   fontIcon: "fi flaticon-pencil",
                //   requiredRoles: ['superadmin', 'admin', 'teacher', 'staff', 'student'],
                // },
              ]
            },
            {
              _name: "CSidebarNavTitle",
              component: "CNavTitle",
              _children: ["Control Panel"],
              name: "Control Panel",
              requiredRoles: ["superadmin", "admin"]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: "Admin Reports",
              to: "/admin-reports",
              fontIcon: "fi flaticon-diagram",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  name: "Summary Reports",
                  component: "CNavItem",
                  to: "/admin-reports/summary-reports",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: "Meet-up Report",
                  to: "/admin-reports/meet-up-report",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                }
              ]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: "Tardy Settings",
              to: "/tardy-settings",
              fontIcon: "fi flaticon-information",
              requiredRoles: ["superadmin", "admin"],
              requiredModule: "Tardy Management",
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  component: "CNavItem",
                  name: "Setup Tardy Appointments",
                  to: "/tardy-settings/appointments",
                  requiredRoles: ["superadmin", "admin"],
                  "data-test-class": "nav-item"
                },
                {
                  component: "CNavItem",
                  name: "Setup Tardy Detention(s)",
                  to: "/tardy-settings/setup-detention",
                  requiredRoles: ["superadmin", "admin"],
                  "data-test-class": "nav-item"
                },
                {
                  component: "CNavItem",
                  name: "Setup Consequences Ladder",
                  to: "/tardy-settings/consequences",
                  requiredRoles: ["superadmin", "admin"],
                  "data-test-class": "nav-item"
                }
              ]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: "Pass Limit / Blocking",
              to: "/blocking",
              fontIcon: "fi flaticon-dashboard",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  component: "CNavItem",
                  name: "Limit Student Pass",
                  to: "/blocking/limit-student-pass",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: "Limit Location Max Cap",
                  to: "/blocking/limit-location-max-cap",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: "Limit Active Pass",
                  to: "/blocking/limit-active-pass",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: "Limit Location Availability",
                  to: "/blocking/limit-location-availability",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: "Contact Control (A/B Polarity)",
                  to: "/blocking/ab-polarity",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: "Pass Blocking",
                  to: "/blocking/pass-blocking",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                }
              ]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: "User Management",
              to: "/user-management/main-users",
              fontIcon: "fi flaticon-followers",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  component: "CNavItem",
                  name: "Main Users",
                  to: "/user-management/main-users",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: "Substitute Users",
                  to: "/user-management/substitute-users",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: "Archived Users",
                  to: "/user-management/archived-users",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                }
              ]
            },
            {
              _name: "CSidebarNavDropdown",
              component: "CNavGroup",
              name: "Pass Settings",
              to: "/pass-settings",
              fontIcon: "fi flaticon-equalizer",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-type": "nav-dropdown"
              },
              items: [
                {
                  component: "CNavItem",
                  name: "Auto Pass",
                  to: "/pass-settings/auto-pass",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: "Pass Times",
                  to: "/pass-settings/pass-times",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: "Periods",
                  to: "/pass-settings/periods",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: "Rooms",
                  to: "/pass-settings/rooms",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                },
                {
                  component: "CNavItem",
                  name: "Pass Transparency",
                  to: "/pass-settings/pass-transparency",
                  requiredRoles: ["superadmin", "admin"],
                  _attrs: {
                    "data-test-class": "nav-item"
                  }
                }
              ]
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "Modules List",
              to: "/modules",
              fontIcon: "fi flaticon-menu",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "File Uploads",
              to: "/file-uploads",
              fontIcon: "fi flaticon-upload",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "CNavItem",
              name: "Help Desk Portal",
              to: "/help-desk-portal",
              fontIcon: "fi flaticon-idea-gray",
              requiredRoles: ["superadmin", "admin"],
              _attrs: {
                "data-test-class": "nav-item"
              }
            },
            {
              _name: "CSidebarNavItem",
              component: "LogoutButton",
              classes: "bg-gradient-blue reverse logout-link",
              addLinkClasses: "bg-gradient-blue reverse logout-link",
              name: "Logout",
              fontIcon: "fi flaticon-log-out",
              requiredRoles: [
                "superadmin",
                "admin",
                "teacher",
                "staff",
                "student"
              ],
              to: "/",
              on: {
                click: () => this.logout()
              },
              _attrs: {
                "data-test-class": "nav-item",
                "data-test-id": "logout"
              }
            }
          ]
        }
      ]
    },
    nextSevenDays() {
      const today = moment().format("MM/DD/YYYY")
      const nextSevenDays = moment().add(7, "days").format("MM/DD/YYYY")
      return today.toString() + "," + nextSevenDays.toString()
    },
    isActiveAppoinmentModule() {
      return this.$store.getters["schools/isActiveAppoinmentModule"]
    }
  },
  created() {
    if (this.user.role.name == "student") {
      this.$store.dispatch("studentAptPass/getTodaysAppointmentPasses")
    }
  },
  mounted() {
    // document.querySelectorAll(".nav-group-toggle").forEach((e) => {
    //   e.addEventListener(
    //     "touchend",
    //     (el) => {
    //       if (el.target.parentElement.__vue__.open) {
    //         document
    //           .querySelectorAll(".c-sidebar-nav-dropdown")
    //           .forEach((a) => {
    //             a.__vue__.open = false
    //           })
    //         el.target.parentElement.__vue__.open = true
    //       } else {
    //         document
    //           .querySelectorAll(".c-sidebar-nav-dropdown")
    //           .forEach((a) => {
    //             a.__vue__.open = false
    //           })
    //         el.target.parentElement.__vue__.open = false
    //       }
    //     },
    //     false
    //   )
    // })
    // document.querySelectorAll(".c-sidebar-nav-dropdown").forEach((e) => {
    //   e.addEventListener(
    //     "click",
    //     (el) => {
    //       if (el.target.parentElement.__vue__.open) {
    //         document
    //           .querySelectorAll(".c-sidebar-nav-dropdown")
    //           .forEach((a) => {
    //             a.__vue__.open = false
    //           })
    //         el.target.parentElement.__vue__.open = true
    //       } else {
    //         document
    //           .querySelectorAll(".c-sidebar-nav-dropdown")
    //           .forEach((a) => {
    //             a.__vue__.open = false
    //           })
    //         el.target.parentElement.__vue__.open = false
    //       }
    //     },
    //     false
    //   )
    // })
    //TODO:
    // const logOutLink = document.getElementsByClassName("logout-link")
    // logOutLink[0].addEventListener("click", () => {
    //   this.logout()
    // })
  },
  methods: {
    logout() {
      this.$store.dispatch("authentication/logOut")
    }
  }
}
</script>
